export const FIRST_COMPARE_MODEL_ANCHOR = 'first-compare-model';
export const SECOND_COMPARE_MODEL_ANCHOR = 'second-compare-model';

export const FIRST_COMPARING_CONV_PARAM = 'first_comparing_conv';
export const SECOND_COMPARE_MODEL_PARAM = 'second_comparing_conv';

export const NOT_AVAILABLE_IN_COMPARE_MODE = 'Not available in compare mode';
